<template>
    <div class="home">
        <MembersHeader/>
        <main class="main">
            <MembersIntro/>
            <MemberPassCode v-if="isShowMemberPassCode"/>
            <!--<div class="container" v-if="!isDashboard">-->
                <!--<BackButton  defaultRoute="/members/dashboard"/>-->
            <!--</div>-->
            <div class="main__inner">

                <router-view></router-view>
            </div>
        </main>

        <MembersFooter :isMember="true"/>


    </div>

</template>

<script>
    import MembersHeader from '../Members/header';
    import MembersIntro from "@/components/studios/StudioIntro";
    import MembersFooter from '@/components/studios/StudioFooter';
//    import BackButton from "@/elements/BackButton";
    import MemberPassCode from "./MemberPassCode";

    export default {
        name: 'Home',
        components: {
            MembersHeader,
            MembersIntro,
            MembersFooter,
//            BackButton,
            MemberPassCode,
        },
        computed: {
            isDashboard() {
                return this.$route.path.includes('dashboard')
            },

            isShowMemberPassCode() {
                return this.$route.name !== 'privacy'
            }
        }
    }
</script>
<style lang="sass" scoped>
    .home
        height: 100%
        display: flex
        flex-direction: column
    .main
        flex: 1
        position: relative
        &__inner
            padding-top: 36px
            padding-bottom: 40px
        ::v-deep
            .intro__inner
                padding-bottom: 45px
    .footer
        flex-shrink: 0
</style>
